export const DOCUMENT_HEADER = [
    {
        label: '标题',
        code: 'title',
        width: 140
    },
    {
        label: '分数',
        code: 'score',
        width: 70
    },
    {
        label: '页码',
        code: 'pageNo',
        align: 'center',
        width: 70
    },
    {
        label: '切片内容',
        code: 'chunkContent',
        minWidth: 200
    },
    {
        label: '关键词',
        code: 'keyword',
        width: 120
    },
    {
        label: '摘要',
        code: 'summary',
        width: 280
    }
];
